<template>
    <v-container fluid class="pa-0">
        <Layout :hidePreview="$route.params.machineId === undefined"
            :hideFilter="$route.query[pk + 'filter'] === undefined">

            <template v-slot:filter>
                <FilterPane :title="'ffff'" :pk="pk">
                    <template v-slot:filters-content>
                        <v-container>
                            <v-row no-gutters v-if="!hideUserTypeFilter" class="mb-3">
                                <UserTypeSelect v-model="userTypeFilter" multiple clearable externaledit>
                                </UserTypeSelect>
                            </v-row>
                            <v-row no-gutters v-if="!hideDepartmentFilter" class="mb-3">
                                <DepartmentSelect v-model="departmentFilter" multiple clearable externaledit>
                                </DepartmentSelect>
                            </v-row>
                            <v-row no-gutters v-if="!hidePartnerCompanyFilter" class="mb-3">
                                <PartnerCompanySelect v-model="partnerCompanyFilter" multiple clearable externaledit>
                                </PartnerCompanySelect>
                            </v-row>
                            <v-row no-gutters v-if="!hideCustomerFilter">
                                <CustomerSelect v-model="customerFilter" externaledit multiple clearable>
                                </CustomerSelect>
                            </v-row>
                            <v-row no-gutters v-if="userInfo.FirmId">
                                <v-checkbox v-model="unLimitFirmFilter" :label="'Show users from other firms'"
                                    class="mt-3 mx-2" hide-details>
                                </v-checkbox>
                            </v-row>
                        </v-container>
                        <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
                    </template>
                </FilterPane>
            </template>


            <template v-slot:list>
                <ListPane :getListMethod="getUserListFromFilter" :optional-filters="filters"
                    :locked-filters="lockedFilters" :paginationEnabled="true" :show-filter-tab="true"
                    :show-sorting-tab="false" :itemsPerPage="25" ref="ListPane" :dialog-trigger="trigger"
                    :dialog-close-trigger="closeTrigger" :dialog-method-config="dialogMethodConfig"
                    :dialogItem="editUser" :pk="pk" @Changed="i => validateChange(i)">

                    <template v-slot:list-item="{ item, handlechanged }">
                        <component :is="getListItemComponent(item.UserTypeId)" :item="item"
                            :warehouseList="listOfWarehouses" :isMe="isMe(item)" @click="edit(item)"
                            @change="handlechanged">
                        </component>
                    </template>

                    <template v-slot:dialog-content="{ item, trigger }">
                        <v-container v-if="item" :key="trigger" class="pa-0">
                            <v-card-text class="pa-3 pt-2 pb-4">
                                <v-row no-gutters>
                                    <v-col class="px-3" :cols="isPhoneBool ? 12 : 6">
                                        <QTextField v-model="item.Name" maxlength="50"
                                            :label="$t('servicesystem.common_objects.user.name')"
                                            :rules="[requiredRule]" :disabled="item.Id == 1 && !isMe(item)" externaledit
                                            class="mb-3">
                                            <!-- lock on id 1 to prevent tampering with the admin user  -->
                                            <template v-slot:prepend-outer>
                                                <v-icon size="18">mdi-text-search</v-icon>
                                            </template>
                                        </QTextField>
                                        <QTextField v-model="item.EmailAdress" maxlength="50"
                                            :label="$t('servicesystem.common_objects.user.email')"
                                            :rules="[requiredRule]" externaledit :disabled="!!item.Id" class="mb-3">
                                            <!-- locked after user creation -->
                                            <template v-slot:prepend-outer>
                                                <v-icon size="18">mdi-email</v-icon>
                                            </template>
                                        </QTextField>
                                    </v-col>
                                    <v-col class="px-3" :cols="isPhoneBool ? 12 : 6">
                                        <LanguageSelect v-model="item.Uiculture" :disabled="item.Id == 1 && !isMe(item)"
                                            externaledit class="mb-3">
                                            <!-- lock on id 1 to prevent tampering with the admin user  -->
                                        </LanguageSelect>
                                        <QTextField v-model="item.Mobile"
                                            :label="$t('servicesystem.common_objects.user.mobile')"
                                            :disabled="item.Id == 1 && !isMe(item)" externaledit class="mb-3">
                                            <!-- lock on id 1 to prevent tampering with the admin user  -->
                                            <template v-slot:prepend-outer>
                                                <v-icon size="18">mdi-phone</v-icon>
                                            </template>
                                        </QTextField>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-divider />

                            <v-row no-gutters>
                                <v-col class="pa-3 mb-3"
                                    :cols="isPhoneBool ? 12 : (getUserTypeIsNotCustomer(item.UserTypeId) ? 6 : 12)">
                                    <h5 v-text="$t('servicesystem.common_objects.user.access')" class="mb-3" />
                                    <UserTypeSelect v-model="item.UserTypeId" externaledit
                                        :disabled="item.Id == 1 && !isMe(item)">
                                        <!-- lock on id 1 to prevent tampering with the admin user  -->
                                    </UserTypeSelect>
                                    <template v-if="getUserTypeIsNotCustomer(item.UserTypeId)">
                                        <QCheckboxInput v-model="item.IsTechnician"
                                            :label="$t('servicesystem.common_objects.user.is_bookable')" externaledit
                                            class="my-5">
                                            <template v-slot:prepend-outer>
                                                <v-icon size="20"
                                                    v-text="item.IsTechnician ? 'mdi-calendar-account' : 'mdi-calendar-remove-outline'">
                                                </v-icon>
                                            </template>
                                        </QCheckboxInput>
                                        <QCheckboxInput v-if="item.UserTypeId <= 2" v-model="item.AllowImportExport"
                                            :label="$t('servicesystem.common_objects.user.has_export_rights')"
                                            externaledit :disabled="item.Id == 1 && !isMe(item)">
                                            <template v-slot:prepend-outer>
                                                <v-icon size="20"
                                                    v-text="item.AllowImportExport ? 'mdi-table-arrow-right' : 'mdi-table-off'">
                                                </v-icon>
                                            </template>
                                        </QCheckboxInput>
                                    </template>
                                    <CustomerSelect v-if="item.UserTypeId != 3 && item.UserTypeId != 5"
                                        v-model="item.CustomerId" externaledit
                                        :label="$t('servicesystem.common_objects.customer.customer')"
                                        :clearable="getUserTypeIsNotCustomer(item.UserTypeId)" class="mt-5">
                                    </CustomerSelect>
                                    <PartnerCompanySelect v-if="item.UserTypeId == 5" v-model="item.PartnerCompanyId"
                                        clearable externaledit>
                                    </PartnerCompanySelect>
                                    <!-- 
                                    <QCheckboxInput v-if="item.Id" v-model="item.Active" :label="'Active'" externaledit>
                                        <template v-slot:prepend-outer>
                                            <v-icon size="20" v-text="item.Active ? 'mdi-account' : 'mdi-account-off'">
                                            </v-icon>
                                        </template>
                                    </QCheckboxInput>
                                    -->
                                </v-col>
                                <template v-if="getUserTypeIsNotCustomer(item.UserTypeId)">
                                    <v-divider :vertical="!isPhoneBool" />
                                    <v-col class="pa-3 mb-3" :cols="isPhoneBool ? 12 : 6">
                                        <h5 v-text="$t('servicesystem.common_objects.user.erp_mapping')" class="mb-3" />
                                        <FirmSelect v-if="userInfo.FirmId" v-model="item.FirmId" clearable externaledit
                                            class="mb-5">
                                        </FirmSelect>
                                        <DepartmentSelect v-model="item.DepartmentId" clearable externaledit>
                                        </DepartmentSelect>
                                        <EmploymentSelect v-model="item.EmploymentId" clearable externaledit
                                            class="my-5">
                                        </EmploymentSelect>
                                        <WarehouseSelect v-if="item.UserTypeId != 5" v-model="item.StoreId" clearable
                                            externaledit>
                                        </WarehouseSelect>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-container>
                    </template>

                    <template v-slot:center-button="{ item }">
                        <v-btn v-if="item.Id" :color="item.Active ? 'error' : 'quaternary'" dark :outlined="item.Active"
                            @click="toggleActive(item)">
                            {{ item.Active ? $t('servicesystem.common_objects.commonterms.deactivate') :
                            $t('servicesystem.common_objects.commonterms.recover') }}
                        </v-btn>
                    </template>

                </ListPane>
            </template>

        </Layout>
    </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
import EmploymentSelect from "@/components/Inputs/EntityDropdowns/EmploymentSelect2.vue";
import FirmSelect from "@/components/Inputs/EntityDropdowns/FirmSelect2.vue";
import PartnerCompanySelect from "@/components/Inputs/EntityDropdowns/PartnerCompanySelect2.vue";
import UserTypeSelect from "@/components/Inputs/EntityDropdowns/UserTypeSelect.vue";
import WarehouseSelect from "@/components/Inputs/EntityDropdowns/WarehouseSelect2.vue";
import LanguageSelect from "@/components/Inputs/LanguageSelect.vue";
import CustomerUserListItem from "@/components/ListItems/User/CustomerUserListItem.vue";
import PartnerUserListItem from "@/components/ListItems/User/PartnerUserListItem.vue";
import UserListItem from "@/components/ListItems/User/UserListItem.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import UserTypeMixin from "@/helpers/Mixins/UserTypeMixin";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
    name: "AdminAccountsList",
    props: {
        pk: {
            type: String,
            default: "UAL-",
        },
        lockedFilters: Object,
        hidePartnerCompanyFilter: Boolean,
        hideCustomerFilter: Boolean,
        hideDepartmentFilter: Boolean,
        hideUserTypeFilter: Boolean,
        userTypeFilterOptions: Array,
    },
    components: {
        FilterPane,
        ListPane,
        Layout,
        UserListItem,
        CustomerUserListItem,
        PartnerUserListItem,
        DefaultLifeCycleFilterGroup,
        UserTypeSelect,
        CustomerSelect,
        DepartmentSelect,
        WarehouseSelect,
        EmploymentSelect,
        FirmSelect,
        LanguageSelect,
        PartnerCompanySelect,
    },
    mixins: [clientAPI, FilterQueryMixin, UserTypeMixin],

    data() {
        return {
            trigger: 1,
            closeTrigger: 1,
            editUser: null,
            listOfWarehouses: null,
            dialogMethodConfig: {
                Create: {
                    IsClientApiMethod: true,
                    Name: 'createUser',
                },
                Change: {
                    IsClientApiMethod: true,
                    Name: 'changeUser',
                },
            },
        };
    },

    mounted() {
        this.updateView();
    },

    methods: {
        async updateView() {
            this.listOfWarehouses = await clientAPI.methods.getAllWarehouses();
        },

        getListItemComponent(userTypeId) {
            if (userTypeId == 5) {
                return 'PartnerUserListItem';
            }
            else if (!this.getUserTypeIsNotCustomer(userTypeId)) {
                return 'CustomerUserListItem';
            }
            else {
                return 'UserListItem';
            }
        },

        edit(user) {
            this.editUser = user;
            this.trigger++;
        },

        handleaddedinlist(item) { this.$refs.ListPane.handleadded(item) },

        handlechangedinlist(item) { this.$refs.ListPane.handlechanged(item) },

        async toggleActive(item) {
            item.loading = true;
            var response = await clientAPI.methods.changeUserActive(item.Id);
            item.loading = false;
            this.closeTrigger++;
            this.handlechangedinlist(response);
        },

        isMe(item) { return item.Id == this.userInfo.Id; },

        validateChange(item) {
            if (this.isMe(item)) {
                if (item.Active == false) { this.$store.dispatch("logout"); }  //Mohahaha ;)
                var typechanged = this.userInfo.UserTypeId != item.UserTypeId;
                var firmchanged = this.userInfo.FirmId != item.FirmId;
                if (typechanged && item.UserTypeId != 1) { //if type no longer admin, redirect to my account (a page they have access to) and force hard reload
                    this.$router.replace({ name: 'MyAccount' });
                    window.location.reload();
                }
                else if (firmchanged) { window.location.reload(); }     //else if firm changes force hard reload
                else { this.$store.dispatch("updateUserInfo", item); } //otherwise just update the user info to the new values
            }
        },
    },

    computed: {
        userInfo() { return this.$store.getters["userInfo"]; },

        newdialogtrigger() { return this.$store.state.triggerevents.newAccountDialogTrigger; },

        filters() {
            if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
                var filters = {
                    SearchWord: this.getQueryParam("filter-keyword", undefined),
                    ActiveState: this.getQueryParam("filter-active", 0),
                    UserTypeIdList: this.userTypeFilter,
                    DepartmentIdList: this.departmentFilter,
                    CustomerIdList: this.customerFilter,
                    PartnerCompanyIdList: this.partnerCompanyFilter,
                    UnLimitFirm: this.unLimitFirmFilter,
                };
                return filters;
            }
            else {
                return undefined;
            }
        },

        userTypeFilter: {
            get() {
                var locked = this.lockedFilters.UserTypeIdList;
                if (locked && locked.length > 0) {
                    return locked;
                }
                else {
                    return this.getQueryParam("filter-usertype", [])
                }
            },
            set(update) { this.setQueryParam("filter-usertype", update); },
        },
        departmentFilter: {
            get() { return this.getQueryParam("filter-department", []); },
            set(update) { this.setQueryParam("filter-department", update); },
        },
        customerFilter: {
            get() { return this.getQueryParam("filter-customer", []); },
            set(update) { this.setQueryParam("filter-customer", update); },
        },
        partnerCompanyFilter: {
            get() { return this.getQueryParam("filter-partnercompany", []); },
            set(update) { this.setQueryParam("filter-partnercompany", update); },
        },
        unLimitFirmFilter: {
            get() { return this.getQueryParam("filter-unlockfirm", false); },
            set(update) { this.setQueryParam("filter-unlockfirm", update); },
        },
    },

    watch: {
        newdialogtrigger() {
            var type = this.userTypeFilter[0] ?? 1;
            var customerId = this.$route.params.customerId ?? null;
            var departmentId = this.$route.params.departmentId ?? (type < 3 ? this.userInfo.DepartmentId : null);
            var partnerCompanyId = this.$route.params.partnerCompanyId ?? null;
            this.editUser = {
                Active: true,
                UserTypeId: type,
                IsTechnician: this.getUserTypeIsNotCustomer(type),
                AllowImportExport: type == 1,
                CustomerId: customerId,
                DepartmentId: departmentId,
                PartnerCompanyId: partnerCompanyId,
                Uiculture: this.userInfo.Uiculture,
                FirmId: this.userInfo.FirmId,
            };
            this.trigger++;
        },
    },
};
</script>

<style lang="scss">
.v-input--checkbox .v-label {
    font-size: 13px !important;
    margin-left: 4px;
}
</style>